<template>
  <div class="top-bar bg-takas-koyu sticky top-0 z-50">
    <div class="relative flex items-center h-14 px-4 max-w-[600px] mx-auto">

      <!-- SOL: Menü Butonu -->
      <div class="absolute left-4 flex items-center gap-2">
        <button @click="openDrawer" class="p-2 rounded-lg active:scale-95 transition">
          <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <!-- ORTA: Logo -->
      <router-link to="/" class="mx-auto">
      <img src="@/assets/logo.png" alt="Logo" class="h-7" />
    </router-link>

      <!-- SAĞ: Aksiyon Butonları -->
      <div class="absolute right-4 flex items-center gap-3">
        <!-- BİLDİRİM BUTONU -->
        <router-link to="/notifications">
          <button class="relative p-2 rounded-lg hover:bg-white/10 transition">
            <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <span class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">3</span>
          </button>
        </router-link>

        <!-- MESAJ BUTONU -->
        <router-link to="/messages">
          <button class="p-2 rounded-lg hover:bg-white/10 transition">
            <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.8-3.6A7.94 7.94 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </button>
        </router-link>
        
      </div>
    </div>

    <!-- ARKA PLAN KARARTMA -->
    <div v-if="isDrawerOpen" @click="closeDrawer" class="fixed inset-0 bg-black/40 z-40"></div>

    <!-- YAN MENÜ -->
    <div class="fixed top-0 left-0 h-full w-72 bg-takas-koyu text-white z-50 shadow-xl transform transition-transform duration-300" 
      :class="isDrawerOpen ? 'translate-x-0' : '-translate-x-full'">

      <div class="p-4 pt-12 space-y-3 text-sm">
        <!-- Profil Özeti -->
        <div class="border-b border-white/20 pb-4 mb-4">
          <div class="flex items-center gap-3">
            <div class="w-12 h-12 rounded-full bg-takas-sari flex items-center justify-center">
              <span class="text-takas-koyu font-bold text-lg">{{ userInitial }}</span>
            </div>
            <div>
              <p class="font-semibold">{{ fullName }}</p>
              <p class="text-xs text-white/60">{{ userEmail }}</p>
            </div>
          </div>
        </div>

        <!-- Menü Öğeleri -->
        <router-link to="/profil">
          <button class="w-full text-left py-2 flex items-center gap-3 hover:bg-white/10 rounded-lg px-2 transition">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span>Profilim</span>
          </button>
        </router-link>

        <router-link to="/my-listings">
          <button class="w-full text-left py-2 flex items-center gap-3 hover:bg-white/10 rounded-lg px-2 transition">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <span>İlanlarım</span>
          </button>
        </router-link>

        <router-link to="/favorites">
          <button class="w-full text-left py-2 flex items-center gap-3 hover:bg-white/10 rounded-lg px-2 transition">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
            <span>Favorilerim</span>
          </button>
        </router-link>

        <router-link to="/settings">
          <button class="w-full text-left py-2 flex items-center gap-3 hover:bg-white/10 rounded-lg px-2 transition">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span>Ayarlar</span>
          </button>
        </router-link>

        <button @click="logout" class="w-full text-left py-2 flex items-center gap-3 hover:bg-white/10 rounded-lg px-2 transition mt-4 border-t border-white/20 pt-4">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>Çıkış Yap</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      isDrawerOpen: false,
      fullName: '',
      userEmail: '',
      userInitial: ''
    }
  },
  created() {
    const user = localStorage.getItem('user')
    if (user) {
      const userData = JSON.parse(user)
      this.fullName = userData.name || 'Kullanıcı'
      this.userEmail = userData.email || 'user@email.com'
      this.userInitial = this.fullName.charAt(0).toUpperCase()
    }
  },
  methods: {
    openDrawer() {
      this.isDrawerOpen = true
    },
    closeDrawer() {
      this.isDrawerOpen = false
    },
    logout() {
      localStorage.removeItem('user')
      this.$router.push('/signin')
    }
  }
}
</script>